export default {
  avatar: {
    marginLeft: -12,
  },
}
